import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VMenu,
        {
          attrs: {
            "data-qa": "language-menu",
            "nudge-bottom": "8",
            "offset-y": "",
            "min-width": "260px",
            "max-width": "260px",
            "z-index": "9999",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    VBtn,
                    _vm._g(
                      {
                        staticClass:
                          "change-language-button rounded-xl px-4 py-1",
                        attrs: {
                          "max-width": "56",
                          "min-width": "56",
                          "max-height": "32",
                          "data-qa": `change-language-button-${_setup.currentLanguage.iso}`,
                          elevation: "0",
                          color: "primary",
                          icon: "",
                        },
                      },
                      on
                    ),
                    [
                      _c(VImg, {
                        attrs: {
                          width: "24",
                          height: "16",
                          contain: "",
                          alt: "language-flag",
                          src: _setup.currentLanguage.flag_image.url,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-4" },
            [
              _c(_setup.LanguagesList, {
                attrs: { languages: _setup.context.available_languages },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }